export const config = {
  basemapURL: process.env.REACT_APP_BASEMAP_URL || "",
  resetEmailCountdownValue: 90, //seconds
  dialogFadeInOut: 200, //miliseconds
};
